// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"160":"22d517f6","211":"0c2958c8","446":"3c331235","453":"e8e05591","971":"eb2d7ae4"}[chunkId] + ".chunk.js";
};